import { ReportingPaths } from '../../../../reporting/reporting.router';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { PieChart, OutstandingPaymentListCard } from '..';
import { useTranslation } from 'react-i18next';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';
import { usePostInvoicesDashboardMutation } from '@client/api';
import { useEffect } from 'react';

export const OutstandingPaymentWidget = () => {
  const { t } = useTranslation('widget');
  const { selectedSpaceIds, selectedDateFrom, selectedDateTo } = useDashboardFilters();

  const [trigger, { data, isLoading }] = usePostInvoicesDashboardMutation();

  useEffect(() => {
    if (!selectedDateFrom || !selectedDateTo) return;
    trigger({
      startDate: selectedDateFrom,
      endDate: selectedDateTo,
      body: { buildingIds: selectedSpaceIds },
    });
  }, [selectedSpaceIds, selectedDateFrom, selectedDateTo, trigger]);

  return (
    <DashboardCardWrapper
      title={t('outstandingPayment.title')}
      to={ReportingPaths.Invoices}
      loading={isLoading || !data}
    >
      <div className="grid grid-cols-2 gap-2 h-80">
        <PieChart agingSummary={data?.agingSummary ?? []} />
        <OutstandingPaymentListCard
          overdueCustomers={data?.topOverdueCustomers ?? []}
          totalOverdueAmount={data?.totalOverdueAmount ?? { value: 0, currency: 'NOK' }}
        />
      </div>
    </DashboardCardWrapper>
  );
};
